import { useRef } from 'react';
import { AudioController } from './AudioController';

let singleton: AudioController | null = null;
export function useAudio(): AudioController {
  const ref = useRef<AudioController | null>(null);
  if (!ref.current) {
    if (!singleton) singleton = new AudioController();
    ref.current = singleton;
  }
  return ref.current;
}
